import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {
  NewSectionMain,
  ButtonsContainer,
  OpenButton,
  OpenLink,
  LinksList,
  LinksListItem,
  LinkItem
} from './index.style'
import RichText from '@components/RichText'
import Spacer from '@components/Spacer'
import PageTransitionLink from '@components/PageTransitionLink';

const NewSection = ({ content, links }) => {

  const [showLinks, setShowLinks] = useState();

  const agreeHandle = () => {
    setShowLinks(true);
  }

  useEffect(() => {
    setTimeout(() => {
      const _ele = document.getElementById('mainSectionTrigger');
      window.scrollTo({
        top: _ele.offsetTop,
        left: 0,
        behavior: "smooth",
      });
    }, 100)
  }, [showLinks]);

  return (
    <NewSectionMain>
      {!showLinks &&
        <RichText
          content={content}
        />
      }
      
      <Spacer size={[20, 40]} />
      {links &&
        <>
          {!showLinks &&
            <ButtonsContainer>
              <OpenLink
                className="white"
                href="/investors"
              >
                I Decline
              </OpenLink>
              <OpenButton
                type="button"
                onClick={agreeHandle}
              >
                I Agree
              </OpenButton>
            </ButtonsContainer>
          }
          {showLinks && 
            <LinksList>
              {links && links.map((link, index) => (
                <LinksListItem key={index}>
                  <LinkItem href={link.file.url} target="_blank">{link.title}</LinkItem>
                </LinksListItem>
              ))}
            </LinksList>
          }
        </>
      }
    </NewSectionMain>
  )
}

NewSection.propTypes = {
  content: PropTypes.object,
  link: PropTypes.object
}

export default NewSection
